<h2 mat-dialog-title>Uploade Service Agreement</h2>
<mat-dialog-content class="mat-typography">
  <div>
    <form [formGroup]="serviceAgreementForm">
        <div>
            <input type="file" accept=".pdf" class="hidden" #uploadLicence
            (change)="uploadDocumentInit($event, uploadLicence)">
            <p>{{selectedFileName}}</p>
            <button  mat-raised-button color="warn" (click)="uploadLicence.click()">Choose File</button>
            <mat-error *ngIf="serviceAgreementForm.controls['agreementFile'].touched && serviceAgreementForm.controls['agreementFile'].hasError('required')">
                Please select a PDF file.</mat-error>
        </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="uploadeServiceAgreement()" cdkFocusInitial>Uploade Service Agreement</button>
</mat-dialog-actions>